<template>
  <div class="tw-w-screen tw-bg-bgMain lg:tw-py-24 md:tw-py-12">
    <div
      class="tab-view-container tw-w-full tw-flex tw-flex-col"
      :class="{ 'animate-slide-up': isVisible }"
    >
      <span
        class="tw-w-full tw-text-center tw-text-4xl tw-font-bold tw-text-textMain tw-mb-10"
        v-html="$t('首页小标题')"
      ></span>

      <b-row>
        <b-col cols="1"> </b-col>
        <b-col cols="10">
          <div class="tw-flex tw-flex-col tw-w-full">
            <div class="tw-flex tw-w-full tw-justify-center">
              <ul class="tw-list-none tw-flex tw-mb-10 tw-gap-20">
                <li
                  class="tw-flex tw-items-center tw-justify-center"
                  v-for="item in tabsList"
                  :key="item.categoryId"
                >
                  <div
                    class="hover:tw-text-primary tw-font-medium tw-flex tw-items-center tw-justify-center tw-py-2 tw-text-lg tw-text-textLight tw-cursor-pointer"
                    :class="{
                      'tab-item-active': item.categoryId == activeTabId,
                    }"
                    @click="handleTabClick(item)"
                  >
                    <span>{{ item.categoryName }}</span>
                  </div>
                </li>
              </ul>
            </div>
            <!-- 卡片网格布局 -->
            <div
              class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-5 tw-justify-center tw-mx-20"
            >
              <!-- 主推产品：占两列 -->
              <div
                v-if="swiperList.length > 0"
                class="swiper-box tw-relative tw-col-span-2 sm:tw-col-span-1 md:tw-col-span-2 lg:tw-col-span-2 tw-rounded-lg tw-bg-white tw-shadow-sm hover:tw-shadow-lg tw-transition-all tw-cursor-pointer"
                @click="handleClickRoute(swiperList[0])"
              >
                <div>
                  <div>
                    <div class="tw-mb-7">
                      <img
                        :src="swiperList[0].icon"
                        alt=""
                        class="tw-w-20 tw-h-20 tw-object-contain"
                      />
                    </div>
                    <span
                      class="tw-text-xl tw-font-semibold tw-text-gray-800"
                      >{{ swiperList[0].name }}</span
                    >
                    <p class="tw-text-sm tw-text-textLight tw-mt-3">
                      {{ swiperList[0].intro }}
                    </p>
                    <button
                      class="swiper-but tw-text-sm tw-py-2 tw-px-4 tw-border tw-transition-colors"
                    >
                      <span>详情</span>
                      <b-icon icon="chevron-right" class="tw-ml-1"></b-icon>
                    </button>
                  </div>
                  <img
                    :src="referrerImg"
                    alt=""
                    class="tw-absolute tw-top-0 tw-right-0 tw-object-cover tw-rounded-xl"
                    style="width: 50%; height: 100%"
                  />
                </div>
              </div>

              <!-- 其余卡片：每行最多4个 -->
              <div
                v-for="item in swiperList.slice(1)"
                :key="item.id"
                class="swiper-box tw-p-4 tw-rounded-lg tw-bg-white tw-shadow-sm hover:tw-shadow-lg tw-transition-all tw-cursor-pointer"
                @click="handleClickRoute(item)"
              >
                <div class="tw-mb-7">
                  <img
                    :src="item.icon"
                    alt=""
                    class="tw-w-20 tw-h-20 tw-object-contain"
                  />
                </div>
                <span class="tw-text-xl tw-font-semibold tw-text-gray-800">
                  {{ item.name }}
                </span>
                <p class="tw-text-sm tw-text-textLight tw-mt-3">
                  {{ item.intro }}
                </p>
                <button
                  class="swiper-but tw-text-sm tw-py-2 tw-px-4 tw-border tw-transition-colors"
                >
                  <span>详情</span>
                  <b-icon icon="chevron-right" class="tw-ml-1"></b-icon>
                </button>
              </div>
            </div>
            <div class="tw-mt-10 tw-text-center">
              <button
                class="swiper-but tw-text-sm tw-py-2 tw-px-5 tw-border tw-transition-colors"
                @click="handleToMore"
              >
                <span>更多产品</span>
                <b-icon icon="chevron-right" class="tw-ml-1"></b-icon>
              </button>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import referrerImg from "@/assets/home/referrer-icon.png";
import { productsApi } from "@/api/modules/home";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      referrerImg,
      tabsList: [],
      isVisible: false,
      observer: null,
      activeTabId: 1,
      hoverId: -1,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        },
        // 添加以下配置
        centeredSlides: false,
      },
    };
  },
  computed: {
    swiperList() {
      if (!this.tabsList || this.tabsList.length <= 0) {
        return [];
      }

      let item = this.tabsList.find(
        (item) => item.categoryId == this.activeTabId,
      );

      // 增加安全检查
      if (!item || !item.products || !Array.isArray(item.products)) {
        return [];
      }

      if (item.products.length > 7) {
        return item.products.slice(0, 7);
      }
      return item.products;
    },
  },
  mounted() {
    const info = JSON.parse(localStorage.getItem("indexInfo"));
    if (info) {
      this.getList();
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    handleToMore() {
      this.$router.push({
        path: "/product",
      });
    },

    handleHover(hover, id) {
      this.hoverId = hover ? id : -1;
    },
    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isVisible) {
              this.isVisible = true;
              // 动画只执行一次，所以可以断开观察器
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0.1, // 当组件10%可见时触发
          rootMargin: "0px 0px -50px 0px", // 提前50px触发
        },
      );

      this.observer.observe(this.$el);
    },
    getList() {
      let info = JSON.parse(localStorage.getItem("indexInfo"));
      this.tabsList = info.recommendProductList.slice(0, 3);

      // 添加"精选推荐"分类
      this.tabsList.unshift({
        categoryId: -1,
        categoryName: this.$t("精选推荐"),
        products: [], // 初始为空，稍后通过API获取
      });

      if (this.tabsList.length > 0) {
        this.activeTabId = this.tabsList[0].categoryId;
        if (this.activeTabId === -1) {
          this.fetchRecommendProducts();
        }
      }
    },

    async fetchRecommendProducts() {
      try {
        const res = await productsApi({
          pageIndex: 1,
          pageSize: 7,
          isRecommend: 1,
        });

        if (res && res.data && res.data.list) {
          // 更新tabsList中categoryId为-1的项的products数据
          const recommendTab = this.tabsList.find(
            (item) => item.categoryId === -1,
          );
          if (recommendTab) {
            this.$set(recommendTab, "products", res.data.list.slice(0, 7));
          }
        }
      } catch (error) {
        console.error("获取推荐产品失败:", error);
      }
    },
    handleClickRoute(row) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (row.id) {
        localStorage.setItem("detailForm", JSON.stringify(row));
        this.$router.push({
          path: "/product/" + row.id + "?isApi=false",
        });
      } else {
        this.$router.push({
          path: "/product",
        });
      }
    },
    handleTabClick(item) {
      this.activeTabId = item.categoryId;
      // 如果点击的是推荐产品(-1)，并且还没有加载过数据，则请求数据
      if (
        item.categoryId === -1 &&
        (!item.products || item.products.length === 0)
      ) {
        this.fetchRecommendProducts();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}
.tab-item-active {
  position: relative !important;
  color: #4077f8 !important; // 激活状态的文字颜色
  transition: all 0.3s ease-in-out;

  &::after {
    content: "";
    position: absolute;
    bottom: -2px; // 调整位置，让线条更贴近文字
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #4077f8;
  }
}

.swiper {
  height: 440px;
  width: 100%;
  max-width: 1440px !important;
  .swiper-slide {
    display: flex;
  }
}

.swiper-box {
  background-color: #fff;
  box-shadow: 0px 0px 30px 0px rgba(48, 66, 137, 0.05);
  border-radius: 8px !important;
  padding: 55px !important;
  position: relative;

  &:hover {
    // 添加轻微阴影
    -webkit-box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.1);
  }
}

.swiper-but {
  color: #666;
  border-radius: 100px;
  &:hover {
    color: #fff;
    background: linear-gradient(90deg, #4077f8 0%, #3d4bdf 100%);
  }
}
</style>
